import styled from "styled-components";
import theme from "styles/theme";

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-right: 0.5rem;
`;

const Label = styled.label`
  font-size: 0.875rem;
  color: #71717a;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;

  &:hover {
    color: #52525b;
  }
`;

const Switch = styled.div<{ $checked: boolean }>`
  width: 39px;
  height: 22px;
  background-color: ${(props) =>
    props.$checked ? theme.colors.primary : theme.colors.backgroundDark};
  border-radius: 20px;
  padding: 2px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  position: relative;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  border: 1px solid ${theme.colors.borderPrimary};
  &:hover {
    background-color: ${(props) =>
      props.$checked ? theme.colors.primary : theme.colors.backgroundDark};
  }
`;

const Thumb = styled.div<{ $checked: boolean }>`
  width: 16px;
  height: 16px;
  background-color: ${theme.colors.primaryDark};
  border-radius: 50%;
  transition: transform 0.2s ease-in-out;
  transform: translateX(${(props) => (props.$checked ? "16px" : "0")});
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
`;

interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
}

export function ToggleSwitch({ checked, onChange, label }: ToggleSwitchProps) {
  return (
    <Container>
      <Switch $checked={checked} onClick={() => onChange(!checked)}>
        <Thumb $checked={checked} />
      </Switch>
      <Label>{label}</Label>
    </Container>
  );
}
